import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { RelocationTemplateCreateStartAction } from 'app/core/store/template/template.actions';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { RelocationDetailCreateStartAction } from './relocation-detail.actions';
import { logger } from 'app/core/util/logger';

@Injectable({ providedIn: 'root' })
export class CreateRelocationGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    logger.debug(`In CreateRelocationGuard`);

    if (route.data.createTemplate) {
      this.store.dispatch(new RelocationTemplateCreateStartAction({ selectedCustomer: null }));
    } else {
      const date = route?.queryParams?.get && route.queryParams.get('date') || null;
      this.store.dispatch(new RelocationDetailCreateStartAction({ date }));
    }
    return of(true);
  }

  getDependencies(): any {
    return [AuthorizationGuard, GetDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'canRelocate',
    };
  }
}
